// ** React Imports
import { useEffect, Fragment, useState } from 'react'
import { Link } from 'react-router-dom'

// ** Custom Components
import NumberInput from '@components/number-input'

// ** Third Party Components
import { X, ArrowRight } from 'react-feather'

import PerfectScrollbar from 'react-perfect-scrollbar'
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Media,
  Badge,
  Button,
  ModalFooter,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap'

// ** Store & Actions
import { useDispatch, connect } from 'react-redux'
import {
  getCartItems,
  deleteCartItem,
  getProduct,
  updateInCart
} from '@src/views/apps/ecommerce/store/actions'
import { FormattedMessage } from 'react-intl'
import { CalculateIcon } from './CalculateIcon'
import { getImageProxyUrl } from '@src/utility/imageProxy.js'
import useAuth from '@hooks/useAuth'

function mapStateToProps(state) {
  const { ecommerce } = state
  return { ecommerce }
}

const CartDropdown = (props) => {
  // ** State
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [isOpen, setModal] = useState(false)
  const [selectedItem, setItem] = useState(false)
  const { can } = useAuth()

  // ** Store Vars
  const dispatch = useDispatch()
  const { ecommerce: store } = props

  // ** ComponentDidMount
  useEffect(() => {
    dispatch(getCartItems())
  }, [])

  // ** Function to toggle Dropdown
  const toggle = () => setDropdownOpen((prevState) => !prevState)

  // ** Function to call on Dropdown Item Click
  const handleDropdownItemClick = (id) => {
    dispatch(getProduct(id))
    toggle()
  }
  const confirmDelete = (item) => {
    setModal(false)
    dispatch(deleteCartItem(item.record_id || item.id))
    setItem(false)
  }
  const renderModal = (item) => {
    if (item) {
      const imageObj = item.variations
        ? item.variations.find((vari) => vari.record_id === item.recordId)[
            'Miniaturas da variação'
          ] &&
          item.variations.find((vari) => vari.record_id === item.recordId)[
            'Miniaturas da variação'
          ][0]
        : item.image
        ? item.image[0]
        : null

      const imgUrl = getImageProxyUrl(item.recordId, imageObj, 'w_62,o_webp')

      return (
        <div>
          <Modal
            isOpen={isOpen}
            toggle={() => {
              setModal(false)
            }}
            className={'modal-dialog-centered modal-sm'}
            key={'Validating Modal'}
          >
            <ModalHeader
              toggle={() => {
                setModal(false)
              }}
            >
              Deseja remover esse item do orçamento?
              <br />
            </ModalHeader>
            <ModalBody>
              <Media key={item.id} className="align-items-center">
                <img
                  className="d-block rounded mr-1"
                  src={imgUrl}
                  alt={item.name}
                  width="62"
                />
                <Media body>
                  <div className="media-heading">
                    <h6 className="cart-item-title">
                      <Link
                        className="text-body"
                        // to={`/apps/ecommerce/shop?product=${item.slug}`}
                        to={`/brands/kit-creator?product=${item.id}`}
                        onClick={() => handleDropdownItemClick(item.id)}
                      >
                        {item.name}
                      </Link>
                    </h6>
                  </div>
                  <div className="cart-item-qty">
                    Quantidade no orçamento: {item.qty} unidades
                    {/* <NumberInput
                      min={10}
                      step={10}
                      size="sm"
                      className="p-0"
                      value={item.qty}
                      onChange={(count) =>
                        dispatch(
                          updateInCart({
                            id: item.id,
                            qty: count
                          })
                        )
                      }
                      style={{ width: '7rem', height: '2.15rem' }}
                    /> */}
                  </div>
                  <h6 className="cart-item-price">
                    R${(item.price * item.qty).toFixed(2)}
                  </h6>
                </Media>
              </Media>
            </ModalBody>
            <ModalFooter>
              <Button
                onClick={() => {
                  setModal(false)
                }}
                color="primary"
                outline
              >
                Cancelar
              </Button>
              <Button
                onClick={() => {
                  confirmDelete(item)
                }}
                color="primary"
              >
                Remover Item
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      )
    }
    return
  }
  // ** Loops through Cart Array to return Cart Items
  const renderCartItems = () => {
    if (store.cart.length) {
      let total = 0

      return (
        <Fragment>
          <PerfectScrollbar
            options={{
              wheelPropagation: false
            }}
            className="scrollable-container media-list"
          >
            {store.cart.map((item) => {
              total += Number(item.price) * item.qty

              const imageSrc = item.variations
                ? item.variations.find(
                    (vari) => vari.record_id === item.recordId
                  )['Miniaturas da variação'] &&
                  item.variations.find(
                    (vari) => vari.record_id === item.recordId
                  )['Miniaturas da variação'][0]
                : item.image
                ? item.image[0]
                : null

              const imgUrl = getImageProxyUrl(
                item.recordId,
                imageSrc,
                'w_62,o_webp'
              )

              return (
                <Media key={item.recordId} className="align-items-center">
                  <img
                    className="d-block rounded mr-1"
                    src={imgUrl}
                    alt={item.name}
                    width="62"
                  />
                  <Media body>
                    <X
                      size={14}
                      className="cart-item-remove"
                      onClick={() => {
                        setModal(true)
                        toggle()

                        setItem(item)
                      }}
                    />

                    <div className="media-heading">
                      <h6 className="cart-item-title">
                        <Link
                          className="text-body"
                          // to={`/apps/ecommerce/shop?product=${item.slug}`}
                          to={`/brands/kit-creator?product=${item.id}`}
                          onClick={() => handleDropdownItemClick(item.id)}
                        >
                          {item.name}
                        </Link>
                      </h6>
                    </div>
                    <div className="cart-item-qty">
                      <NumberInput
                        min={item.minimumQuantity || 50}
                        step={10}
                        size="sm"
                        className="p-0"
                        value={item.qty}
                        onChange={(count) =>
                          dispatch(
                            updateInCart({
                              id: item.record_id || item.id,
                              qty: count
                            })
                          )
                        }
                        style={{ width: '7rem', height: '2.15rem' }}
                      />
                    </div>
                    <h6 className="cart-item-price">
                      {(item.price * item.qty).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })}
                    </h6>
                  </Media>
                </Media>
              )
            })}
          </PerfectScrollbar>
          <li className="dropdown-menu-footer">
            <div className="d-flex justify-content-between mb-1">
              <h6 className="font-weight-bolder mb-0">Total:</h6>
              <h6 className="text-primary font-weight-bolder mb-0">
                {Number(total).toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                })}
              </h6>
            </div>
            {can('createOrders') && (
              <Button.Ripple
                tag={Link}
                to="/apps/ecommerce/checkout"
                color="primary"
                block
                onClick={toggle}
                className="w-100 mt-1 request-mockups tw-flex tw-items-center tw-justify-center tw-p-2"
              >
                Personalizar Produtos
                <ArrowRight className="tw-ml-4" />
              </Button.Ripple>
            )}
          </li>
        </Fragment>
      )
    } else {
      return (
        <p className="m-0 p-1 text-center">
          <FormattedMessage id="Your cart is empty" />
        </p>
      )
    }
  }

  const showCartItemCountMessage = (num) => {
    if (num === 1) {
      return (
        <>
          1 <FormattedMessage id="item" />
        </>
      )
    } else {
      return (
        <>
          {num ? num : 0} <FormattedMessage id="items" />
        </>
      )
    }
  }

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      tag="li"
      className="dropdown-cart nav-item mr-25"
    >
      <DropdownToggle
        tag="a"
        className="nav-link r-0 position-relative"
        aria-label="shopping-cart"
      >
        <CalculateIcon />

        {store.cart.length > 0 ? (
          <Badge pill color="primary" className="badge-up">
            {store.cart.length}
          </Badge>
        ) : null}
      </DropdownToggle>
      <DropdownMenu
        right
        tag="ul"
        className="dropdown-menu-media dropdown-cart mt-0"
      >
        <li className="dropdown-menu-header">
          <DropdownItem tag="div" className="d-flex" header>
            <h4 className="notification-title mb-0 mr-auto">
              <FormattedMessage id="My cart" />
            </h4>
            <Badge color="light-primary" pill>
              {showCartItemCountMessage(store.cart.length)}
            </Badge>
          </DropdownItem>
        </li>
        {renderCartItems()}
        {renderModal(selectedItem)}
      </DropdownMenu>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(CartDropdown)
